import { useEffect } from 'react';
import useLocalStorage from './useLocalStorage';

/**
 * Color mode hook with smooth transition on theme switch.
 * Default: light mode. User choice persisted in localStorage.
 */
const useColorMode = () => {
  const [colorMode, setColorMode] = useLocalStorage('color-theme', 'light');

  useEffect(() => {
    const className = 'dark';
    const body = window.document.body;

    // Enable smooth transitions for theme switching
    body.classList.add('theme-transition');

    if (colorMode === 'dark') {
      body.classList.add(className);
    } else {
      body.classList.remove(className);
    }

    // Remove transition class after animation completes to avoid
    // transition flicker on page load
    const timer = setTimeout(() => {
      body.classList.remove('theme-transition');
    }, 300);

    return () => clearTimeout(timer);
  }, [colorMode]);

  return [colorMode, setColorMode];
};

export default useColorMode;

